export enum OrderStatusEnum {
  InCart = 'In Cart',
  Quotation = 'Quotation',
  Order = 'Order',
  InProgress = 'In Process',
  ReadyForPayment = 'Ready for payment',
  Paid = 'Paid',
  Packing = 'Packing',
  Shipped = 'Shipped',
  InTransit = 'In Transit',
  Delivered = 'Delivered',
  Cancelled = 'Cancelled',
}
